import { CurrencyPipe } from '@angular/common';
import { Component, input } from '@angular/core';
import { KENDO_SKELETON } from '@progress/kendo-angular-indicators';
import { KENDO_CARD, KENDO_GRIDLAYOUT } from '@progress/kendo-angular-layout';
import { ClientDetailedDto } from '@unity/clients';
import { CardSummarySharedComponent } from '../composed/card-summary-shared/card-summary-shared.component';

@Component({
  selector: 'unity-card-client-budget-summary-shared',
  standalone: true,
  imports: [KENDO_CARD, KENDO_GRIDLAYOUT, KENDO_SKELETON, CardSummarySharedComponent, CurrencyPipe],
  templateUrl: './card-client-budget-summary-shared.component.html',
  styleUrl: './card-client-budget-summary-shared.component.scss',
})
export class CardClientBudgetSummarySharedComponent {
  public readonly $client = input.required<ClientDetailedDto | undefined>({ alias: 'client' });
  public readonly $isLoading = input.required<boolean>({ alias: 'isLoading' });
}
